import { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { A, H1, P } from '../../components/typography';
import { Alert } from '../../components/alert';
import { Box, Col, Container, Flex, Row } from '../../components/grid';
import { breakpoints, navigation } from '../../constants';
import { CompetitionForm } from '../../components/competition-form';
import { Layout } from '../../components/layout';

const Competition = ({ title }) => {
  const [success, setSuccess] = useState(false);

  return (
    <Layout title={title}>
      <Flex height="100%" flexDirection="column" pb={3}>
        <BackgroundImage>
          <Container pt={3}>
            <H1>Thank you for your feedback!</H1>
            <Row mt={3}>
              <Col width={{ xs: 12 / 12, lg: 6 / 12 }} offset={[0, 0, 0, 3 / 12]}>
                {success ? (
                  <Flex flexDirection="column" bg="white" py={2} px={{ sm: 1, md: 3 }} width="100%">
                    <Box px={2}>
                      <Alert icon={null} type="success" heading="Good luck!">
                        You are in the running to win a $100 Nando’s Voucher. If successful you will be contacted via
                        the email you provided.
                      </Alert>
                    </Box>
                  </Flex>
                ) : (
                  <CompetitionForm setSuccess={setSuccess} />
                )}
                <P variant={3} textAlign="center" mt={2}>
                  Your feedback is very much appreciated and will help us improve our services for the future. If there
                  are more pressing matters please don’t hesitate to{' '}
                  <A variant={3} target="_blank" href={navigation.CONTACT}>
                    contact us
                  </A>
                  .
                </P>
              </Col>
            </Row>
          </Container>
        </BackgroundImage>
      </Flex>
    </Layout>
  );
};

const BackgroundImage = styled.div`
  background-image: url(/static/images/decal/header/left.jpg);
  background-repeat: no-repeat;
  background-size: 20%;

  @media (min-width: ${breakpoints.md}) {
    background-size: auto;
  }
`;

Competition.propTypes = {
  title: PropTypes.string,
};

Competition.defaultProps = {
  title: undefined,
};

export function getStaticProps() {
  return {
    props: {
      title: 'Competition',
    },
  };
}

export default Competition;
